import createFeatureManagementInstance from '@justeat/feature-management';
import axios from 'axios';
import { getCookieByName } from '../lib/helpers';

const sixtySeconds = 60 * 1000;
const fiveSeconds = 5000;

class JetFmLog {
  info(message, tags, payload = {}) {
    console.info('[jetfm]', message, tags, payload);
  }

  warn(message, tags, payload = {}) {
    console.warn('[jetfm]', message, tags, payload);
  }
}

export class JetFm {
  constructor() {
    this.service = null;
    this.anonUserId = retrieveOrGenerateOrderModuleUniqueId();
  }

  init() {
    const config = {
      keyPrefix: 'jet-minisites',
      cdn: {
        host: 'https://features.api.justeattakeaway.com',
        scope: 'jet-minisites',
        environment: process.env.NODE_ENV || 'production',
        key: '',
        poll: true,
        pollInterval: sixtySeconds, // default value in docs
      },
      contextGetter: () => {
        return { anonUserId: this.anonUserId };
      },
      onTrack: (key, variant) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'experiment_active',
          tms_data: {
            eventData: {
              experiment_variant: variant,
              experiment_key: key,
            },
          },
        });
      },
    };

    config.log = new JetFmLog();
    const httpClient = axios.create({
      timeout: fiveSeconds,
    });

    const service = createFeatureManagementInstance(config, httpClient);
    const self = this;

    return service
      .loadFromCdn()
      .then(() => {
        self.service = service;
        return self.service.getBooleanValue('feature_show_ordermodule');
      })
      .catch(() => {
        // Silently fail
        return false;
      });
  }
}

function retrieveOrGenerateOrderModuleUniqueId() {
  const userIdCookie = getCookieByName('order_module_uid');

  if (userIdCookie) {
    return userIdCookie;
  } else {
    const uniqueId = `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
    document.cookie = `order_module_uid=${uniqueId}; path=/; max-age=3600`;
    return uniqueId;
  }
}
